import { render, staticRenderFns } from "./forget-pwd.vue?vue&type=template&id=ef257ed0&scoped=true"
import script from "./forget-pwd.vue?vue&type=script&lang=js"
export * from "./forget-pwd.vue?vue&type=script&lang=js"
import style0 from "./forget-pwd.vue?vue&type=style&index=0&id=ef257ed0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef257ed0",
  null
  
)

export default component.exports